export enum RentItemCategory {
    INVOICE = "Billed",
    MIGRATED_INVOICE = "Migrated",
    UNBILLED = "Unbilled",
}
